import axios from 'axios';

// Same-origin `/api`: webpack-dev-server proxies it in `serve`, IIS/host does it in production.
const BASE_URL = '/api';

// eslint-disable-next-line import/no-mutable-exports
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

export default api;
